var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown dropright border-bottom-item"},[_c('button',{staticClass:"dropdown-item",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeTooth()}}},[_vm._v(" Remove Tooth ")])])}
var staticRenderFns = []

export { render, staticRenderFns }